import Vue from 'vue';
import Vuex from 'vuex';
import { Theme } from '@/plugins/theme';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    barColor: 'white',
    logo: '/img/tu-logo.png',
    title: 'TruValidate',
    iDVs: Array<string>(),
    agreed: false,
    session: '',
  },
  getters: {
    isDefault: (state) => {
      if (state.barColor === 'white' && state.logo === '/img/tu-logo.png' && state.title === 'TruValidate') {
        return true;
      } else {
        return false;
      }
    },
    hasAgreed: (state) => {
      return state.agreed;
    },
    theme: (state): Theme => {
      return { headerColor: state.barColor, title: state.title, logo: state.logo };
    },
  },
  mutations: {
    default(state) {
      state.barColor = 'white';
      state.logo = '/img/tu-logo.png';
      state.title = 'TruValidate';
    },
    theme(state, payload) {
      state.barColor = payload.barColor;
      state.logo = payload.logo;
      state.title = payload.title;
    },
    iDV(state, payload) {
      state.iDVs.push(payload);
    },
    iDVClear(state) {
      state.iDVs = new Array<string>();
    },
    agree(state) {
      state.agreed = true;
    },
    session(state, payload) {
      state.session = payload;
    },
  },
  actions: {
    MAKE_DEFAULT({ commit }) {
      commit('default');
    },
    THEMED({ commit }, theme) {
      commit('theme', theme);
    },
    SET_IDV({ commit }, payload) {
      commit('iDV', payload);
    },
    SET_SESSION({ commit }, payload) {
      commit('session', payload);
    },
    AGREE({ commit }) {
      commit('agree');
    },
    CLEAR_ALL({ commit }) {
      commit('default');
      commit('iDVClear');
      commit('session', '');
    },
  },
  plugins: [],
});
